export const getRedirectUri = (
  productReference: string,
  redirectScreen: string
): string => {
  return `${window.location.origin}/${productReference}/${redirectScreen}`;
};
